import React, { useReducer } from "react";

import CartContext from "./Cart-context";

const defaultCartState = {
  items: [],
  totalAmount: 0,
};
const cartReducer = (state, action) => {
  switch (action.type) {
    case "ADD": {
      const updatedAmount =
        state.totalAmount + action.item.price * action.item.amount;

      const sameItemIndex = state.items.findIndex(
        (item) => item.id === action.item.id
      );

      const sameItem = state.items[sameItemIndex];
      let updatedItems;
      if (sameItem) {
        const updatedItem = {
          ...sameItem,
          amount: sameItem.amount + action.item.amount,
        };
        updatedItems = [...state.items];
        updatedItems[sameItemIndex] = updatedItem;
      } else {
        updatedItems = state.items.concat(action.item);
      }

      return {
        items: updatedItems,
        totalAmount: updatedAmount,
      };
    }
    case "REMOVE": {
      const existingItemIndex = state.items.findIndex(
        (item) => item.id === action.id
      );
      const existingItem = state.items[existingItemIndex];
      const updatedAmount = state.totalAmount - existingItem.price;
      let updatedItems;

      if (existingItem.amount === 1) {
        updatedItems = state.items.filter((item) => item.id !== action.id);
      } else {
        const updatedItem = {
          ...existingItem,
          amount: existingItem.amount - 1,
        };
        updatedItems = [...state.items];
        updatedItems[existingItemIndex] = updatedItem;
      }
      return {
        items: updatedItems,
        totalAmount: updatedAmount,
      };
    }

    default:
      return defaultCartState;
  }
};
function CartProvider(props) {
  const [cartState, dispatchCartAction] = useReducer(
    cartReducer,
    defaultCartState
  );

  const addItem = (item) => dispatchCartAction({ type: "ADD", item });
  const removeItem = (id) => dispatchCartAction({ type: "REMOVE", id });

  const cartContext = {
    items: cartState.items,
    totalAmount: cartState.totalAmount,
    addItem: addItem,
    removeItem: removeItem,
  };

  return (
    <CartContext.Provider value={cartContext}>
      {props.children}
    </CartContext.Provider>
  );
}

export default CartProvider;
